import { useUserContext } from "../../../Hooks/useUserContext";
import { PaperActions } from "../../../Shared/PaperActions";
import React from "react";
import { Button } from "@material-ui/core";
import { AiSparkleIcon } from "../../../Shared/AiSparkleIcon";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ImportIcon from "@material-ui/icons/GetApp";
import UndoIcon from "@material-ui/icons/Undo";

export function RecipeFormActions(props) {
	const user = useUserContext(props.config);
	const isBusy = props.isExecuting;
	const disableEdits = !user.canEditRecipe || isBusy;

	return (
		<PaperActions
			className="no-print rb-recipe-actions"
			style={{ marginTop: 10 }}
			left={
				<React.Fragment>
					<Button
						variant="contained"
						color="primary"
						disabled={disableEdits}
						onClick={props.onSaveClick}>
						<SaveIcon style={{ marginRight: 10 }} /> Save
					</Button>
					{props.onOptimizeClick && !props.canUndo ? (
						<Button
							variant="contained"
							disabled={disableEdits}
							onClick={props.onOptimizeClick}>
							<AiSparkleIcon style={{ marginRight: 10 }} /> Optimize
						</Button>
					) : null}
					{props.canUndo ? (
						<Button
							variant="outlined"
							onClick={props.onUndoClick}
							disabled={isBusy}>
							<UndoIcon style={{ marginRight: 10 }} /> Undo Optimize
						</Button>
					) : null}
					<Button
						variant="contained"
						onClick={props.onImportClick}
						disabled={isBusy}>
						<ImportIcon style={{ marginRight: 10 }} /> Import
					</Button>
					<Button
						variant="contained"
						onClick={props.onCancelClick}
						disabled={isBusy}>
						<CancelIcon style={{ marginRight: 10 }} /> Cancel
					</Button>
				</React.Fragment>
			}
			right={null} />
	);
}
